import { observer } from "mobx-react-lite";
import React from "react";
import { Grid } from "semantic-ui-react";
import { IRecipientModel } from "../../../../Models/Recipient";
import RecipientCard from "../Card/Card";

export interface IRecipientContainerProps {
  recipients: IRecipientModel[];
  onRecipientSelected: (recipient: IRecipientModel | undefined) => void;
  selectedRecipient: IRecipientModel | undefined;
  onEditClick: () => void | {};
  onDeleteClick: () => void | {};
}

const RecipientContainer: React.FC<IRecipientContainerProps> = ({
  recipients,
  onRecipientSelected,
  selectedRecipient,
  onEditClick,
  onDeleteClick,
}) => {
  
  return (
    <>
      {recipients.map((r: IRecipientModel) => {
        return (
          <Grid.Column
            data-testid="recipient-container"
            key={r.id}
          >
            <RecipientCard
              recipient={r}
              onSelected={onRecipientSelected}
              selectedRecipient={selectedRecipient}
              onEditClick={onEditClick}
              onDeleteClick={onDeleteClick}
            />
          </Grid.Column>
        );
      })}
    </>
  );
};

export default observer(RecipientContainer);
